import { Injectable } from '@angular/core';
import { JwtHelperService } from '@auth0/angular-jwt';
import { SessionCustomerInfo } from '../avantoeats-util/models/session/SessionCustomerInfo';
import { AvantoCognitoService } from './avanto-cognito.service';

@Injectable({
  providedIn: 'root'
})
export class AvantoUserAuthService {
  private jwtHelper: JwtHelperService;

  constructor(private cognito: AvantoCognitoService) {
    this.jwtHelper = new JwtHelperService();
  }

  getIdToken() {
    return new Promise((resolve, reject) => {
      this.cognito.getCognitoUser()
        .then((user) => {
          user.getSession((err, session) => {
            if (err) {
              reject(err)
            } else if (!session.isValid()) {
              console.log("Invalid session.");
              reject("Invalid session");
            } else {
              resolve(session.getIdToken().getJwtToken());
            }
          })
        })
        .catch((err) => {
          reject(err)
        })
    })
  }

  getCustomerInfo() {
    return new Promise<SessionCustomerInfo>((resolve, reject) => {
      this.getIdToken()
        .then((idToken) => {
          resolve(this.getCustomerInfoFromToken(idToken))
        })
        .catch(err=>{
          reject(err);
        })
    })
  }

  private getCustomerInfoFromToken(token): SessionCustomerInfo {
    const tokenInfo = this.jwtHelper.decodeToken(token)
    const formattedPhoneNumber = tokenInfo["phone_number"]; //TODO: <== Put this in a user friendly format
    return new SessionCustomerInfo(tokenInfo["cognito:username"], tokenInfo["name"], tokenInfo["email"], formattedPhoneNumber, tokenInfo["email_verified"], tokenInfo["phone_number_verified"]);
  }
}
